export default __webpack_public_path__ + "static/media/H.24f1cd3c.wav";